const enum PeopleCardRouteViewType {
    Front = 'front',
    Organization = 'org',
    Compose = 'compose',
    ShowMore = 'showMore',
    Members = 'members',
    GroupShowMore = 'groupShowMore',
    NameEditSpoke = 'name',
    ContactDetailsEditSpoke = 'contact',
    WorkDetailsEditSpoke = 'work',
    OtherEditSpoke = 'other',
    AddressEditSpoke = 'address',
}

export default PeopleCardRouteViewType;
